module.exports = __webpack_public_path__ + "img/espadin_2.075ef894.jpg";